import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import { monthOptions, yearOptions } from "../../../config";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import { unitServiceTableConfig, unitEntriTableConfig } from "./config";
import moment from "moment";
import { HttpStatus } from "../../../../../common/Constants";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { saveAs } from "file-saver";
//  type = 'unit_servis' | 'unit_entri'

export default class LaporanUnitMTDByMekanik extends Component {
  constructor(props) {
    super(props);
    this.currentMonth = Number(moment().format("MM"));
    this.currentYear = Number(moment().format("YYYY"));
    this.state = {
      month: monthOptions.find((item) => item.value === this.currentMonth),
      year: yearOptions.find((item) => item.value === this.currentYear),
      dataTable: [],
      config: [],
    };
  }

  componentDidMount() {
    const { type } = this.props;

    this.setState({
      config:
        type === "unit_servis" ? unitServiceTableConfig : unitEntriTableConfig,
    });
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    const currCabang = this.props.kodeCabang?.value;
    const prevCabang = prevProps.kodeCabang?.value;
    if (currCabang !== prevCabang) {
      this.fetchData();
    }
  }

  handleChangeValue = (name, value) => {
    this.setState((prevValue) => ({ ...prevValue, [name]: value }));
  };

  handleSearch = () => {
    this.fetchData();
  };

  fetchData = () => {
    const { type } = this.props;
    if (type === "unit_servis") {
      return this.fetchDataUnitServiceMTD();
    }
    return this.fetchDataUnitEntriMTD();
  };

  fetchDataUnitServiceMTD = async () => {
    const { setError, onTriggerLoading, kodeCabang } = this.props;
    const { year, month } = this.state;
    const userId = localStorage.getItem("userId");

    if (!kodeCabang?.value) return;
    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn:
        Api.create("NAGAMAS_REPORT_DTO").getLaporanUnitServiceMTDByMechanicH23,
      setError: setError,
      menuName:
        "Dashboard Level Mekanik & SA - Laporan Unit Servis MTD by Mekanik",
      args: {
        kodeCabang: kodeCabang?.value,
        year: year?.value,
        month: month?.value,
        type: "MECHANICSA",
        idUser: userId,
      },
    });

    onTriggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const data = res.data.data || [];
      this.setState({
        dataTable: data,
      });
    }
  };

  fetchDataUnitEntriMTD = async () => {
    const { setError, onTriggerLoading, kodeCabang } = this.props;
    const { year, month } = this.state;
    const userId = localStorage.getItem("userId");

    if (!kodeCabang?.value) return;
    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn:
        Api.create("NAGAMAS_REPORT_DTO").getLaporanUnitEntriMTDByMekanikH23,
      setError: setError,
      menuName:
        "Dashboard Level Mekanik & SA - Laporan Unit Entri MTD by Mekanik",
      args: {
        kodeCabang: kodeCabang?.value,
        year: year?.value,
        month: month?.value,
        employeeId: userId,
      },
    });

    onTriggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const data = res.data.data || [];
      this.setState({
        dataTable: data,
      });
    }
  };

  handlePrint = async () => {
      const { onTriggerLoading, type, setError } = this.props;
      const { dataTable, config } = this.state;
  
      const title =
        type === "unit_servis"
          ? "Laporan Unit Servis MTD by Mekanik"
          : type === "unit_entri"
            ? "Laporan Unit Entri MTD by Mekanik"
            : " ";
  
      const fileName = title.split(" ").join("_");
  
      const reqBody = {
        filename: fileName,
        sheets: [
          {
            name: title,
            headers: config.map((item) => item.label,
            ),
            data: dataTable.map((item, index) => {
              return {
              "Tim Mekanik": item.mechanicName || item.timMekanik,
              "Last Month": item.lastMonth,
              "This Month": item.thisMonth,
              Growth: item.growth,
              Proyeksi: item.proyeksi,
              "Productivity/Day Last Month": item.productivityDayLastMonth,
              "Productivity/Day This Month": item.productivityDayThisMonth,
            }
            }),
          },
        ],
      };
      onTriggerLoading();
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT").generateExcelFromPayload,
        setError: setError,
        menuName: `Dashboard Mekanik SA - ${title}`,
        args: reqBody,
      });
  
      onTriggerLoading();
      if (res.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, fileName + ".xlsx");
      }
    };

  render() {
    const { month, year, config, dataTable } = this.state;
    return (
      <React.Fragment>
        <FlexView className="margin-top-15px" style={{ gap: "20px" }}>
          <SimpleDDL
            id="select_options_bulan"
            box="search"
            name="month"
            containerclassname="width width-150px"
            placeholder="Bulan"
            options={monthOptions}
            value={month}
            onChange={(value, { name }) => this.handleChangeValue(name, value)}
          />
          <SimpleDDL
            id="select_options_tahun"
            box="search"
            name="year"
            containerclassname="width width-150px"
            placeholder="Tahun"
            options={yearOptions}
            value={year}
            onChange={(value, { name }) => this.handleChangeValue(name, value)}
          />
          <SimpleButton
            id="btn_search"
            text="Cari"
            className="margin margin-top-5px"
            onClick={() => this.handleSearch()}
          />
        </FlexView>
        <SimpleDataTable
          data={dataTable}
          columns={config}
          options={{ pagination: false }}
        />
        <FlexView hAlignContent="right" className="margin-top-20px">
          <SimpleButton
            id="btn_print"
            text="CETAK"
            onClick={() => this.handlePrint()}
          />
        </FlexView>
      </React.Fragment>
    );
  }
}
